import { Directive, AfterContentInit, inject } from '@angular/core';

import { HisBaseGlobalsService } from '../../core/service/base/his-base-globals.service';
import { HisUiService } from '../../core/service/base/his-ui.service';

import { MultiSelect } from 'primeng/multiselect';

/**
 * Sets default values for p-multiSelect component bindings that are universally used in H1.
 *
 * Default values are as follows:
 * defaultLabel:
 */
@Directive( {
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'p-multiSelect',
    standalone: false
} )
export class HisMultiselectDefaultsDirective implements AfterContentInit {
    hisBaseGlobalsService = inject(HisBaseGlobalsService);
    private hisUiService = inject(HisUiService);
    private multiSelectRef = inject(MultiSelect);


    ngAfterContentInit(): void {
        if ( this.multiSelectRef ) {
            this.multiSelectRef.defaultLabel = this.hisUiService.translate( 'common.pleaseChoose' );
            this.multiSelectRef.ngOnInit();
        }
    }

}
